import React, { Component } from 'react'

export default class Error extends Component {
  render() {
    return (
      <div>This path doesn't exist</div>
    )
  }
}
